import { render, staticRenderFns } from "./CsWidgetPhoneInput.vue?vue&type=template&id=b2119e62&"
import script from "./CsWidgetPhoneInput.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsWidgetPhoneInput.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports